export default __webpack_public_path__ + "static/media/Standard43.3427e9e3.png";